const brandConfigs = {
  clean2u: {
    organizationName: 'Clean2u',
    faviconHref: '/branding/clean2u/favicon.ico',
    manifestHref: '/branding/clean2u/manifest.json',
    themeColor: '#2c7be5',
  },
  getplan: {
    organizationName: 'GetPlan',
    faviconHref: '/branding/getplan/favicon.png',
    manifestHref: '/branding/getplan/manifest.json',
    themeColor: '#2c7be5',
  },
};

const DEFAULT_BRAND = 'getplan';

// REACT_APP_ORGANIZATION_NAME is baked into the build from the deployment's
// .env (e.g. "Clean2u" or "GetPlan"), so it directly tells us which brand
// this build belongs to - no hostname sniffing needed.
export const detectBrand = () => {
  const orgName = (process.env.REACT_APP_ORGANIZATION_NAME || '').trim().toLowerCase();
  return brandConfigs[orgName] ? orgName : DEFAULT_BRAND;
};

export const getBrandConfig = () => brandConfigs[detectBrand()];

export const applyBranding = () => {
  const { organizationName, faviconHref, manifestHref, themeColor } = getBrandConfig();
  const publicUrl = process.env.PUBLIC_URL || '';

  document.title = `${organizationName} | App`;

  const setLink = (rel, href) => {
    const link =
      document.head.querySelector(`link[rel="${rel}"]`) ||
      document.head.appendChild(document.createElement('link'));
    link.rel = rel;
    link.href = `${publicUrl}${href}`;
  };

  setLink('shortcut icon', faviconHref);
  setLink('manifest', manifestHref);

  const themeMeta = document.head.querySelector('meta[name="theme-color"]');
  if (themeMeta) themeMeta.content = themeColor;
};
